import { useState, useEffect, useRef, useContext} from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getIdFromPath } from "../../ui/utils/getIdFromPath";
import { FddApi } from "../../ui/services/server-fdd";
import { PageSizeProvider } from "../../ui/context/page/PageSizeProvider";
import { Button } from "@mui/material";
import { SignatureContext } from "./context/SignatureContext";
import { TYPES } from "../../config/constants/typesReducers";

import "../../ui/styles/pages/Signature.css";
import { STATUS_MODULE, STATUS_VIEWER } from "../../config/constants/status";
import { useCallback } from "react"
//import { IoDocumentTextOutline as LuFileSignature } from "react-icons/io5";
import { LuFileSignature } from "react-icons/lu";

import { HiArrowNarrowLeft } from "react-icons/hi";
//import { IoMdDocument as HiOutlineDocument } from "react-icons/io";
import { PDFViewer } from "../../ui/components/PDFViewer";
import { SignatureForm } from "./components/form-container/FormContainer";
import MODULES from "../../config/constants/modules";
import { LoaderContext } from "../../ui/context/loader/LoaderContext";

const { LOADER } = TYPES;

export const SignaturePage = () => {
  const viewerRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const signaturePageRef = useRef(null);

  //const { signatureState:{header:{title, user, date}}, signatureDispatch } = useContext(SignatureContext);
  const {signatureState, signatureDispatch} = useContext(SignatureContext);

  const { loaderDispatch } = useContext(LoaderContext);
  const [statusSignature, setStatusSignature] = useState(STATUS_MODULE.IDLE);
  const [statusViewer, setStatusViewer] = useState(STATUS_VIEWER.IDLE);
  const [alreadySigned, setAlreadySigned] = useState(false);

  const [document, setDocument] = useState(null);

  useEffect(() => {
    switch (statusSignature) {
      case STATUS_MODULE.IDLE: return loaderDispatch({type: LOADER.START, payload: 'Cargando borrador...'});
      case STATUS_MODULE.LOADED: return loaderDispatch({type: LOADER.LOADED});
      case STATUS_MODULE.ERROR: return loaderDispatch({type: LOADER.ERROR, payload: 'Error al cargar el borrador'});
    }
  }, [statusSignature, loaderDispatch]);

  const fetchSignature = useCallback(() => {
    const signatureId = getIdFromPath(location.pathname);

    FddApi.getSignature(signatureId)
    .then((response) => {
      if (response.hasError) throw new Error(response.message);
      // status 2 = ya firmado
      if (response.status === 2) {
        setAlreadySigned(true);
        setStatusSignature(STATUS_MODULE.LOADED);
        return;
      }
      signatureDispatch({
        type: TYPES.SIGNATURE.LOAD_SIGNATURE,
        payload: response.body
      })
      setStatusSignature(STATUS_MODULE.LOADED);
    }).catch((error)=>{
      console.log('[SIGNATURE PAGE] Error al obtener datos de la petición', error);
      setStatusSignature(STATUS_MODULE.ERROR);
    });
  },[location.pathname, signatureDispatch]);

  const fetchDocument = useCallback(() => {
    const signatureId = getIdFromPath(location.pathname);

    setStatusViewer(STATUS_VIEWER.IDLE);

    FddApi.getDocument(signatureId, 'sign')
    .then((response) => {
      if (response.hasError) throw new Error(response.message);
      console.log('[SIGNATURE PAGE] Se ha cargado el documento');
      setDocument(response?.body);
      setStatusViewer(STATUS_VIEWER.LOADED);
    })
    .catch((error) => {
      console.log("[PDF Viewer] Error -> ", error);
      setStatusViewer(STATUS_VIEWER.ERROR);
    });
  },[location.pathname]);

  useEffect(() => {

    fetchSignature();
    fetchDocument();

    return () => { signatureDispatch({
        type: TYPES.SIGNATURE.CLEAN,
      });
    };
  }, [signatureDispatch, fetchDocument, fetchSignature]);

  useEffect(() => {
    const currentViewer = viewerRef.current;
    if (!currentViewer) return;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[viewerRef.current]);

  return (
    <>
      {statusSignature !== STATUS_MODULE.IDLE && alreadySigned && (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
          minHeight: '100vh', gap: '16px', padding: '32px', textAlign: 'center'
        }}>
          <LuFileSignature style={{ fontSize: '4rem', color: 'var(--primary-color)' }} />
          <h2 style={{ fontSize: '1.5rem', fontWeight: 700 }}>Documento ya firmado</h2>
          <p style={{ color: '#666', maxWidth: 400 }}>
            Este enlace ya fue utilizado para firmar el documento. No es posible firmar nuevamente.
          </p>
          <Button variant="outlined" onClick={() => navigate('/')}>Ir al inicio</Button>
        </div>
      )}
      {
        statusSignature !== STATUS_MODULE.IDLE && !alreadySigned &&
        <PageSizeProvider>
          <div ref={signaturePageRef} className="signature">
            <section 
              className="signature__header">
              <div className="mb-2">
                <Button
                  variant="text"
                  onClick={() => navigate('/')}
                  startIcon={
                    <HiArrowNarrowLeft />
                  }> Inicio
                </Button>
              </div>
              
              <div className="signature__title mb-2">
                <LuFileSignature className="signature__title--icon xxxl-text"/>
                <h1 className=" xxxl-text signature__title--text">{signatureState.signature.header.title}</h1>
              </div>
              <p className="grey-text md-text mb-1">De: {signatureState.signature.header.user.email}</p>
              <p className="grey-text md-text">Fecha: {new Date(signatureState.signature.header.date).toLocaleString()}</p>
            </section>
            
            <div className="signature__container">
              <PDFViewer
                viewerRef={viewerRef}
                status={statusViewer}
                setStatus={setStatusViewer}
                document={document} 
                fetchDocument={fetchDocument}
                module={MODULES.SIGNATURE}
                />
              <SignatureForm parentRef={signaturePageRef}/>
            </div>
          </div>
        </PageSizeProvider>
      }
    </>
  )
}
